<script>
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Sifranti_Klubi_vnos-sl.json';
import en from '@/Prevodi/Sifranti_Klubi_vnos-en.json';
import it from '@/Prevodi/Sifranti_Klubi_vnos-it.json';
export default {
  components: {
    Notification
  },
  emits: ['osvezi', 'odjava'],
  data() {
    return {
      prevodi: false,
      naziv: '',
      naslov: '',
      kraj: '',
      posta: '',
      email: '',
      telefon: '',
      text: '',
      types: '',
      ShowNoti: false,
      licence: [],
      klubi: [],
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.GetLicence();
    this.GetKlubi();
    this.prevodi = true;
  },
  methods: {
    GetLicence() {
      axios.post('./api/nastavitve/licence/izpis/', {}, {withCredentials: true}).then((response) => {
        this.licence = response.data.licence || [];
      }).catch((napaka) => {
        this.text = `Licenca za letališče ne obstaja. Prosimo kontaktirajte administratorja.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    GetKlubi() {
      axios.get('./api/sifranti/klubi/izpis/').then((response) => {
        this.klubi = response.data.klubi || [];
      }).catch((napaka) => {
        this.text = `Prišlo je do napake pri branju vnesenih klubov. Preverite, da obstaja vnos kluba.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    ValidateLicenceLimit() {
      // Ajdovščina = id 5 - VSI klubi se štejejo kot na Ajdovščini
      const LETALISCA_AJDOVSCINA_ID = 5;

      // Najdi licenco za Ajdovščino
      const licence = this.licence.find(l => l.id_letalisca === LETALISCA_AJDOVSCINA_ID);
      if (!licence) {
        this.text = `Licenca za letališče Ajdovščina ne obstaja. Prosimo kontaktirajte administratorja.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
        return false;
      }

      // Preštej koliko klubov je že v bazi (sifrant_klubov)
      const steviloKlubov = this.klubi.length;

      // Preveri ali je dosežena omejitev klubov
      if (steviloKlubov >= licence.st_klubov) {
        this.text = `Presegli ste dovoljeno število klubov (${licence.st_klubov}). Zakupite dodatno licenco za povečanje limita.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
        return false;
      }

      return true;
    },
    Add() {
      if (this.naziv !== '' && this.naslov !== '' && this.email !== '' && this.telefon !== '' && this.kraj !== '' && this.posta !== '') {

        // Preveri omejitev klubov pred submit-om
        if (!this.ValidateLicenceLimit()) {
          return;
        }

        var podatki = new URLSearchParams();
        podatki.append('naziv', this.naziv);
        podatki.append('naslov', this.naslov);
        podatki.append('email', this.email);
        podatki.append('posta', this.posta);
        podatki.append('kraj', this.kraj);
        podatki.append('tel', this.telefon);
        axios.post('./api/sifranti/klubi/vnos/', podatki, {withCredentials: true}).then((response) => {
          // alert('Vnos podatkov uspešen');
          this.text = 'Vnos podatkov uspešen';
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.naziv = '';
          this.naslov = '';
          this.email = '';
          this.posta = '';
          this.kraj = '';
          this.telefon = '';
          this.GetKlubi();
          this.GetLicence();
          this.$emit('osvezi');
          var requiredPolja = ['naziv', 'naslov', 'email', 'telefon', 'kraj', 'posta'];
          this.ResetRequired(requiredPolja);
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri vnosu podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri vnosu podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      } else {
        var requiredPolja = ['naziv', 'naslov', 'email', 'telefon', 'kraj', 'posta'];
        this.CheckInputs(requiredPolja);
        // alert('Mankajoči vnosi podatkov!');
        this.text = "Napaka pri vnosu, preveri ali imaš vse pomembne podatke izpolnjene! Obvezni podatki so obrobljeni z redečo!";
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]);
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="container p-2" v-if="prevodi">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: naziv.length > 0 }" class="label" for="naziv">{{$t('labels.naziv')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="naziv" v-model="naziv" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: naslov.length > 0 }" class="label" for="naslov">{{$t('labels.naslov')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="naslov" v-model="naslov" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: posta.length > 0 }" class="label" for="posta">Poštna št.</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="posta" v-model="posta" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: kraj.length > 0 }" class="label" for="kraj">{{$t('labels.kraj')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="kraj" v-model="kraj" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: telefon.length > 0 }" class="label" for="telefon">{{$t('labels.telefon')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="telefon" v-model="telefon" required />
      </div>
    </div>

    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: email.length > 0 }" class="label" for="email">E-mail(upravitelja)</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="email" v-model="email" required />
      </div>
    </div>

    <div class="m-2">
      <button @click.prevent="Add()" class="btn btn-primary rounded-pill btn-add col-12">{{$t('buttons.vnesi')}}</button>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>